import { AccountInterface } from '@/interfaces/account';
import type { AccountBase } from '@/models/AccountViewModel';

export function mapAccountToAccountInterface(
  account: AccountBase,
): AccountInterface {
  return {
    id: account.AccountId,
    userId: 0, // Not available in source object
    accountNumber: account.AccountNumber ?? '',
    name: account.Name,
    type: account.ClassificationName,
    subtype: account.SubClassificationName,
    balance: account.Balance,
    value: account.Balance, // Using Balance for value since source doesn't have separate value
    currency: 'USD', // Assuming USD since not specified in source
    openDate: account.CreatedDate,
    institution: account.InstitutionName,
    institutionId: account.InstitutionId,
    // Setting gain/loss/income fields to 0 since not available in source
    unrealizedShortTeamGainLoss: 0,
    unrealizedLongTeamGainLoss: 0,
    realizedShortTeamGainLoss: 0,
    realizedLongTeamGainLoss: 0,
    dividends: 0,
    interest: 0,
    netAccruedIncome: 0,
    lastUpdated: account.LastUpdated,
    hasError: account.HasError,
    // Optional fields
    change: undefined,
    percentageChange: undefined,
  };
}
